type SuspenseErrorChannel = "error" | "warning";

const FIREBASE_AUTH_NETWORK_REQUEST_FAILED = "auth/network-request-failed";
const NO_AUTH_USER = "no_auth_user";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const collectErrorValues = (
  error: unknown,
  values: string[] = [],
  depth = 0,
): string[] => {
  if (depth > 4) return values;

  if (typeof error === "string") {
    values.push(error);
    return values;
  }

  if (!isRecord(error)) return values;

  const message = error.message;
  if (typeof message === "string") values.push(message);

  const code = error.code;
  if (typeof code === "string") values.push(code);

  const type = error.type;
  if (typeof type === "string") values.push(type);

  collectErrorValues(error.cause, values, depth + 1);
  collectErrorValues(error.data, values, depth + 1);
  collectErrorValues(error.meta, values, depth + 1);
  collectErrorValues(error.shape, values, depth + 1);

  return values;
};

export const isFirebaseAuthNetworkRequestFailed = (error: unknown) =>
  collectErrorValues(error).some((value) =>
    value.includes(FIREBASE_AUTH_NETWORK_REQUEST_FAILED),
  );

export const isNoAuthUserError = (error: unknown) =>
  collectErrorValues(error).some((value) => value.includes(NO_AUTH_USER));

export const getSuspenseErrorCaptureChannel = (
  error: unknown,
): SuspenseErrorChannel =>
  isFirebaseAuthNetworkRequestFailed(error) || isNoAuthUserError(error)
    ? "warning"
    : "error";
